export default __webpack_public_path__ + "static/placeholder-5b210047ed8377c238acc26bd153f4d7.png";